import { __awaiter, __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import CatalogItem from '@slickdeals/durango/dist/javascript/core/catalogItem';
import { catalogItem } from '@slickdeals/durango/dist/javascript/decorators/catalogItem';
import { stateable } from '@slickdeals/durango/dist/javascript/decorators/stateable';
import Mediator from '@slickdeals/durango/dist/javascript/core/mediator';
import { joinLoyalty } from '../utilities/loyalty';
import { name as cashbackJoinModalName, MediatedEvents as CashbackJoinModalMediatedEvents, } from './cashbackJoinModal/cashbackJoinModal';
/* eslint-disable import/extensions */
import { name as CashbackActivatorModalName } from './cashbackActivatorModal/cashbackActivatorModal';
/* eslint-enable import/extensions */
import { name as heapName } from '../heap/heap';
import '@slickdeals/blueprint-twig/javascript/components/button';
import '../../scss/patterns/cashbackActivator.scss';
export const name = 'CashbackActivator';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-cashbackActivator";
    ClassNames["Heading"] = "js-cashbackActivator_heading";
    ClassNames["ActivateButton"] = "js-cashbackActivator_button";
})(ClassNames || (ClassNames = {}));
export const dependencies = Object.assign(Object.assign({}, Injector.createDependency(CashbackActivatorModalName, InjectorScope.Factory)), Injector.createDependency(heapName, InjectorScope.Singleton));
let CashbackActivator = class CashbackActivator extends CatalogItem {
    constructor(modal, heap, options) {
        super(options);
        this.modal = modal;
        this.heap = heap;
        this.options = options;
        this.heap = heap;
    }
    /** Initializing the component */
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.init.call(this);
            this.element = yield CatalogItem.loadElement(name, this.options);
            Mediator.addListener(cashbackJoinModalName, CashbackJoinModalMediatedEvents.Activate, this.handleDynamicUpdate.bind(this));
            // Pass in store logo
            yield this.modal.initModal(this.options.cashbackActivatorData, this.heap);
            // collect button element and set click event listener on it,
            const activateButton = this.element.querySelector(`.${ClassNames.ActivateButton}`);
            if (activateButton) {
                activateButton.addEventListener('click', this.handleClick.bind(this));
            }
            const { cashbackRate } = this.options.cashbackActivatorData;
            const state = {
                cashbackRate,
                headingText: `Get ${cashbackRate} Cashback on this Deal`,
                buttonText: 'Activate Cashback',
            };
            this.initState(state);
        });
    }
    handleClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            this.handleActivatedState(event);
            const result = yield joinLoyalty('dd-cashback-activator');
            if (result.isLoyaltyUser) {
                // Applies data attribute to See Deal button on deal details
                const seeDealCta = document.getElementById('largeBuyNow');
                seeDealCta.setAttribute('data-show-loyalty-outclick-flow', '1');
            }
            this.modal.showModal();
        });
    }
    /**
     * Updates component UI state, dependent on button click
     * @param event Button click
     */
    handleActivatedState(event) {
        // Update component state
        this.setState({
            headingText: `${this.getState().cashbackRate} ${this.options.activatedHeadingText}`,
            buttonText: this.options.activatedCtaText,
        });
        const button = event.target;
        button.innerHTML = this.getState().buttonText;
        button.disabled = true;
        const heading = this.element.querySelector(`.${ClassNames.Heading}`);
        heading.innerHTML = this.getState().headingText;
    }
    /**
     * Updates component UI state, used by mediator (ex. cashbackJoinModal)
     */
    handleDynamicUpdate() {
        // Update component state
        this.setState({
            headingText: `${this.getState().cashbackRate} ${this.options.activatedHeadingText}`,
            buttonText: this.options.activatedCtaText,
        });
        const button = this.element.querySelector(`.${ClassNames.ActivateButton}`);
        button.innerHTML = this.getState().buttonText;
        button.disabled = true;
        const heading = this.element.querySelector(`.${ClassNames.Heading}`);
        heading.innerHTML = this.getState().headingText;
    }
};
CashbackActivator = __decorate([
    stateable(name),
    catalogItem(name),
    injectable(name, dependencies)
], CashbackActivator);
export default CashbackActivator;
